<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.833008 15.2053C0.833008 16.4727 1.93566 17.5001 3.29584 17.5001H16.7031C17.1216 17.5001 17.5332 17.4007 17.8991 17.2113C19.0881 16.5958 19.5165 15.1987 18.856 14.0908L12.1524 2.84752C11.929 2.47291 11.5975 2.16407 11.1955 1.95595C10.0065 1.34045 8.50711 1.73962 7.84655 2.84752L1.14294 14.0908C0.939674 14.4317 0.833008 14.8153 0.833008 15.2053Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.9134 6.66592C10.913 6.20567 10.5217 5.83287 10.0395 5.83325C9.55721 5.83363 9.16659 6.20705 9.16699 6.6673L9.17062 11.6672C9.17102 12.1275 9.56228 12.5003 10.0445 12.4999C10.5268 12.4995 10.9174 12.1261 10.917 11.6659L10.9134 6.66592ZM10.9134 14.5832C10.9134 14.123 10.5224 13.7499 10.0402 13.7499C9.55793 13.7499 9.16699 14.123 9.16699 14.5832V14.9999C9.16699 15.4601 9.55793 15.8333 10.0402 15.8333C10.5224 15.8333 10.9134 15.4601 10.9134 14.9999V14.5832Z"
      fill="white"
    />
  </svg>
</template>
